export default __webpack_public_path__ + "static/media/img12.7436c594.jpg";